import { createSlice } from '@reduxjs/toolkit'

// Initial state
const initialState = {
  userData: {},
  isLoading: false,
  error: null,
  uniqueDeviceId: null
}

// Create auth slice using Redux Toolkit
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true
      state.error = null
    },
    loginSuccess: (state, action) => {
      state.isLoading = false
      state.userData = action.payload
      state.error = null
    },
    loginFailure: (state, action) => {
      state.isLoading = false
      state.error = action.payload
    },
    logout: (state) => {
      state.userData = {}
      state.error = null
    },
    setUniqueDeviceId: (state, action) => {
      state.uniqueDeviceId = action.payload
    }
  }
})

// Export actions
export const { 
  loginStart, 
  loginSuccess, 
  loginFailure, 
  logout, 
  setUniqueDeviceId 
} = authSlice.actions

// Export reducer
export default authSlice.reducer

